import React from 'react'
import HeaderSix from '../components/header/HeaderSix'
import BannerVideo from '../components/banner/BannerVideo'
import TrustBarTechDigit from '../components/techdigit/TrustBarTechDigit'
import ThreePillarStrip from '../components/techdigit/ThreePillarStrip'
import AboutTechDigit from '../components/techdigit/AboutTechDigit'
import ServicesTechDigit from '../components/techdigit/ServicesTechDigit'
import ProcessTechDigit from '../components/techdigit/ProcessTechDigit'
import FaqTechDigit from '../components/techdigit/FaqTechDigit'
import CtaTechDigit from '../components/techdigit/CtaTechDigit'
import FooterSix from '../components/footer/FooterSix'
import ScrollAnimation from '../components/motion/ScrollAnimation'
import NewsletterLeadModal from '../components/techdigit/NewsletterLeadModal'

function HomeSix() {
    return (
        <div className="index-six">
            <HeaderSix />
            {/* <ScrollAnimation direction="up" delay={0.06} duration={0.5}> */}
                <BannerVideo />
            {/* </ScrollAnimation> */}

            <ScrollAnimation direction="up" delay={0.08} duration={0.48}>
                <ThreePillarStrip />
            </ScrollAnimation>
            <ScrollAnimation direction="fade" delay={0.04} duration={0.42}>
                <TrustBarTechDigit />
            </ScrollAnimation>
            <ScrollAnimation direction="left" delay={0.1} duration={0.52}>
                <AboutTechDigit />
            </ScrollAnimation>
            <ScrollAnimation direction="up" delay={0.08} duration={0.48}>
                <ProcessTechDigit />
            </ScrollAnimation>
            <ScrollAnimation direction="right" delay={0.1} duration={0.52}>
                <ServicesTechDigit />
            </ScrollAnimation>

            <ScrollAnimation direction="up" delay={0.08} duration={0.46}>
                <FaqTechDigit />
            </ScrollAnimation>
            {/* <ScrollAnimation direction="up" delay={0.05} duration={0.44}>
                <CtaTechDigit />
            </ScrollAnimation> */}
            <FooterSix />
            <NewsletterLeadModal />
        </div>
    )
}

export default HomeSix
